import React from "react";
import { TextBox, Validator } from "devextreme-react";

class TextField extends React.PureComponent {
  render() {
    const setValidationRules = [
      {
        type: "required",
        message: "Este campo es requerido",
      },
    ];
    const {
      label,
      mode,
      disabled,
      value,
      onChange,
      onPaste,
      onFocusOut,
      onFocusIn,
      id,
      optional,
      customRules,
      skipValidation,
      required,
      useInputChange,
      ...rest
    } = this.props;

    if (customRules !== undefined) {
      setValidationRules.push(customRules);
    }
    return (
      <div
        className="field-newDenuncia"
        style={{ marginLeft: optional ? 20 : 0 }}
      >
        {label && (
          <h3>
            <p>
              {label}{" "}
              {required ? <span className="label-red-requerido"> *</span> : ""}
            </p>
          </h3>
        )}

        {id && id === "telefono" ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
            }}
          >
            <span style={{ marginRight: "5px" }}>+56</span>
            <TextBox
              mode={mode || null}
              disabled={disabled}
              value={value}
              onFocusOut={onFocusOut}
              onFocusIn={onFocusIn}
              onValueChanged={onChange}
              id={id}
              valueChangeEvent={useInputChange ? "input" : "focusout"}
              onPaste={onPaste}
              {...rest}
            >
              <Validator
                validationRules={!skipValidation ? setValidationRules : []}
              />
            </TextBox>
          </div>
        ) : (
          <TextBox
            mode={mode || null}
            disabled={disabled}
            value={value}
            onFocusOut={onFocusOut}
            onFocusIn={onFocusIn}
            onValueChanged={onChange}
            id={id}
            valueChangeEvent={useInputChange ? "input" : "focusout"}
            onPaste={onPaste}
            {...rest}
          >
            {required && <Validator
              validationRules={!skipValidation ? setValidationRules : []}
            />}
          </TextBox>
        )}
      </div>
    );
  }
}

export default TextField;
